import {equals, isEmpty, isNil} from 'ramda';
import {isNilOrEmpty} from 'ramda-adjunct';

import {type CampaignResponseBody} from '@dms/api/sales';
import {type CampaignFilter} from '@dms/api/shared';

import {Nullish} from 'shared/web';

import {CampaignTargeting} from '../types/CampaignTargeting';

const areCampaignFiltersEqual = (left: CampaignFilter | Nullish, right: CampaignFilter | Nullish) =>
  equals(left?.makes?.toSorted() ?? [], right?.makes?.toSorted() ?? []) &&
  equals(left?.models?.toSorted() ?? [], right?.models?.toSorted() ?? []);

export const areCampaignsOverlapping = (
  campaign: CampaignResponseBody | Nullish,
  targeting: CampaignTargeting
) => {
  if (isNil(campaign) || isEmpty(campaign)) {
    return false;
  }

  if (campaign.isAppliedToAllVehicles && targeting.isAppliedToAllVehicles) {
    return true;
  }

  if (isNilOrEmpty(campaign.filter?.makes)) {
    return false;
  }

  return areCampaignFiltersEqual(campaign.filter, targeting.filter);
};
